import { useContext, useEffect, useState } from 'react';
import { services } from '../services/api';
import { useParams } from 'react-router-dom';
import { generateKey } from '../utils/inputsRules';

import IconUI from '../components/ui/icon_ui'
import { FiMail } from "react-icons/fi";
import Location from '../assets/img/card/Location.svg'
import Phone from '../assets/img/card/Phone.svg'
import PhoneMC from '../assets/img/card/PhoneMC.svg'
import WEB from '../assets/img/card/WEB.svg'

import User from '../assets/img/card/User.svg'
import GifLoader from "../components/ui/gifLoader"
import PopUpServer from '../components/ui/popUpServer';

import { GlobalContext } from '../context/global_context';
import { useHistory } from 'react-router-dom';


export function PublicServerAdminView() {

    const { idOfi } = useContext(GlobalContext)
    const { statePublicServerAdmin, setStatePublicServerAdmin } = useContext(GlobalContext)
    const history = useHistory()
    const { idOficina, idFuncionario } = useParams()



    useEffect(async () => {

        let isMounted = true
        if (isMounted) {
            let dataAPI

            setStatePublicServerAdmin({ ...statePublicServerAdmin, loading: true })
            if (idOfi) {
                dataAPI = await services("GET", `funcionarios/mostrarOficina/${idOfi}`)
            }
            else {
                dataAPI = await services("GET", `funcionarios/mostrarOficina/${idOficina}`)
            }

            if (dataAPI.status === "success") {
                setStatePublicServerAdmin({ ...statePublicServerAdmin, infoOfi: dataAPI.data.oficina, infoFun: dataAPI.data.funcionario, loading: false })
            }

        }

        return () => {
            isMounted = false
        }
    }, []);

    const [modal, setModal] = useState(false)
    const showModal = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto' // Opcional: agrega un desplazamiento suave
        });
        setModal(true)
    }

    const hiddenModal = () => {
        setModal(false)
    }

    return (
        <>
            {statePublicServerAdmin.loading === true ?
                <GifLoader />
                :
                <div id="publicServer" className='publicServer'>
                    <div className="container text-center ">
                        <div className="d-block justify-content-center">
                            <div className="pt-3">
                                <h2 className="text-center text-large text-secondary">
                                    Bienvenido al Directorio Estatal de Servidores Públicos
                                </h2>
                            </div>
                            <div>

                                <div className="mb-4 row row-cols-1 row-cols-md-1 g-4 ">
                                    <div className="col ml-4">
                                        <div className="card card--rounded ">
                                            <div className="card-body ">
                                                <div className="d-inline-flex pb-4 input-group justify-content-center ">
                                                    <div className='col-2-justify-content-center col-md-2 mb-2 '>
                                                        <img src={User} style={{ height: 100, width: 100 }} alt="user logo" />
                                                    </div>
                                                    <div className='text-md-start text-center ms-2'>
                                                        <h4 className='text-bolder'>{statePublicServerAdmin.infoOfi.oficina}</h4>
                                                        <h5 className=" text-bolder card-title">{(statePublicServerAdmin.infoFun?.titular ? statePublicServerAdmin.infoFun.titular : null)}</h5>
                                                        <h6>{(statePublicServerAdmin.infoFun?.cargo ? statePublicServerAdmin.infoFun.cargo : null)}</h6>
                                                    </div>
                                                </div>

                                                <div className="d-inline-flex pb-4  input-group text-center">
                                                    <div className='col-2 '>
                                                        <img src={Location} style={{ height: 25, width: 25 }} alt="location logo" />
                                                    </div>
                                                    <div className='col-8 text-start'>
                                                        <h6 className='text-bold'>{statePublicServerAdmin.infoOfi.direccion ? statePublicServerAdmin.infoOfi.direccion : "Sin dirección"}</h6>
                                                    </div>
                                                </div>

                                                <div className="d-inline-flex pb-4  input-group text-center">
                                                    <div className='col-2  text-guinda'>
                                                        <IconUI size={'25px'}>
                                                            <FiMail />
                                                        </IconUI>
                                                    </div>
                                                    <div className='d-inline-flex col-8 text-start'>
                                                        <div className='text-bold text-start'>
                                                            Correo:
                                                        </div>
                                                        {statePublicServerAdmin.infoOfi ?
                                                            statePublicServerAdmin.infoOfi.emails?.length !== 0 ?
                                                                statePublicServerAdmin.infoOfi.emails?.map((item) => {
                                                                    return (
                                                                        item.length < 1 ?
                                                                            <div key={generateKey}>
                                                                                sin correo
                                                                            </div>
                                                                            :
                                                                            <div key={generateKey}>
                                                                                {'\n' + item + ' \b '}
                                                                            </div>
                                                                    )
                                                                })
                                                                :
                                                                <div className='ms-3'> sin correo</div>
                                                            :
                                                            <div className='ms-3'> sin correo</div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-inline-flex pb-4 justify-content-start input-group text-center">
                                                    <div className='col col-md-2'>
                                                        <img src={Phone} style={{ height: 25, width: 25 }} alt="phone logo" />
                                                    </div>
                                                    <div className='d-inline-flex col col-md-4 text-start'>
                                                        <div >
                                                            <div className='text-bold'>
                                                                Teléfono:
                                                            </div>
                                                            {statePublicServerAdmin.infoOfi.telefono ?
                                                                statePublicServerAdmin.infoOfi.telefono.map((item) => {
                                                                    return (
                                                                        item.numero?.length < 1 ?
                                                                            <div key={generateKey()}>
                                                                                -
                                                                            </div>
                                                                            :
                                                                            <div key={generateKey()}>
                                                                                {'\n' + item.numero + '\n \b -'}
                                                                            </div>
                                                                    )
                                                                })
                                                                :
                                                                <div> sin numero</div>
                                                            }
                                                        </div>

                                                        <div>
                                                            <div className='ms-3 text-bold' key={generateKey()}>
                                                                Extension:
                                                            </div>
                                                            {statePublicServerAdmin.infoOfi.telefono ?
                                                                statePublicServerAdmin.infoOfi.telefono.map((item) => {
                                                                    return (
                                                                        item.extensiones.length < 1 ?
                                                                            <div key={generateKey()} >
                                                                                -
                                                                            </div>
                                                                            :
                                                                            <div className='ms-3' key={generateKey()}>
                                                                                {item.extensiones + '\n '}
                                                                            </div>
                                                                    )
                                                                })
                                                                :
                                                                <div className='ms-3'> sin numero</div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className='col col-md-2 text-center'>
                                                        <img src={PhoneMC} style={{ height: 25, width: 25 }} alt="phonemc logo" />
                                                    </div>
                                                    <div className='col col-md-4 text-start'>
                                                        <h6 className='text-bold'> M.C. </h6>
                                                        {statePublicServerAdmin.infoOfi.telefono ?
                                                            statePublicServerAdmin.infoOfi.telefono.map((item) => {
                                                                return (
                                                                    item.marcacion_corta.length < 1 ?
                                                                        <div key={generateKey()}>
                                                                            -
                                                                        </div>
                                                                        :
                                                                        <div className='ps-4' key={generateKey()}>
                                                                            {item.marcacion_corta + '\n '}
                                                                        </div>
                                                                )
                                                            })
                                                            :
                                                            <div> sin numero</div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-inline-flex pb-4  input-group text-center">
                                                    <div className='col-2'>
                                                        <img src={WEB} style={{ height: 25, width: 25 }} alt="web logo" />
                                                    </div>
                                                    {statePublicServerAdmin.infoOfi.url_web ?
                                                        <div className='col-4 text-start'>
                                                            {statePublicServerAdmin.infoOfi.url_web.map((url) => {
                                                                return <p><a className='text-bold' href={url}>{url}</a></p>
                                                            })}
                                                        </div>
                                                        :
                                                        <div className='col-4 text-start text-bold'>
                                                            Sin Página Web
                                                        </div>

                                                    }

                                                    <div className='col-6 d-flex flex-row-reverse'>
                                                        <button className='pill ' onClick={showModal}>{statePublicServerAdmin.infoFun ? "Datos Funcionario" : "Asignar Funcionario"}</button>
                                                    </div>
                                                </div>
                                                {
                                                    modal === true ?
                                                        <PopUpServer idFuncionario={statePublicServerAdmin.infoFun?.id} onclose={hiddenModal}>
                                                        </PopUpServer>
                                                        :
                                                        null
                                                }

                                                <div>
                                                    <hr />
                                                    <h3> Datos Privados</h3>

                                                    <div className="d-inline-flex pb-4 justify-content-right input-group text-center">
                                                        <div className='col-2'>
                                                            <img src={Phone} style={{ height: 25, width: 25 }} alt="phone logo" />
                                                        </div>
                                                        <div className='d-flex col-4 text-start '>
                                                            <div >
                                                                <div className='text-bold'>
                                                                    Teléfono:
                                                                </div>
                                                                {statePublicServerAdmin.infoFun ?
                                                                    statePublicServerAdmin.infoFun.numero?.length !== 0 ?
                                                                        statePublicServerAdmin.infoFun.numero?.map((item) => {
                                                                            return (
                                                                                item.length < 1 ?
                                                                                    <div key={generateKey}>
                                                                                        sin numero
                                                                                    </div>
                                                                                    :
                                                                                    <div key={generateKey}>
                                                                                        {'\n' + item + ' \b '}
                                                                                    </div>
                                                                            )
                                                                        })
                                                                        :
                                                                        <div className='ms-3'> sin numero</div>
                                                                    :
                                                                    <div className='ms-3'> sin numero</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className='col-2 justify-content-right text-guinda'>
                                                            <IconUI size={'25px'}>
                                                                <FiMail />
                                                            </IconUI>
                                                        </div>
                                                        <div >
                                                            <div className='text-bold text-start'>
                                                                Correo:
                                                            </div>
                                                            {statePublicServerAdmin.infoFun ?
                                                            statePublicServerAdmin.infoFun.email?.length !== 0 ?
                                                                statePublicServerAdmin.infoFun.email?.map((item) => {
                                                                    return (
                                                                        item.length < 1 ?
                                                                            <div key={generateKey}>
                                                                                sin correo
                                                                            </div>
                                                                            :
                                                                            <div key={generateKey}>
                                                                                {'\n' + item + ' \b '}
                                                                            </div>
                                                                    )
                                                                })
                                                                :
                                                                <div className='ms-3'> sin correo</div>
                                                            :
                                                            <div className='ms-3'> sin correo</div>
                                                        }
                                                        </div>
                                                    </div>


                                                </div>

                                                <div>
                                                    <iframe width="90%" height="500" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src={`https://maps.google.com/maps?width=100%25&height=600&hl=en&q=${statePublicServerAdmin.infoOfi.longitud},${statePublicServerAdmin.infoOfi.latitud}&t=&z=14&ie=UTF8&iwloc=B&output=embed`}>
                                                        <a href="https://www.maps.ie/distance-area-calculator.html">distance maps</a>
                                                    </iframe>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}